<template>
  <TCalloutExclamationBlock :data-test="'TCalloutErrorGeneric-' + dataTestName">
    {{ $t('generic_error') }}
  </TCalloutExclamationBlock>
</template>

<script setup lang="ts">
import { $t } from '@teachino/shared-i18n';
import TCalloutExclamationBlock from './TCalloutExclamationBlock.vue';
defineProps({
  dataTestName: { type: String, required: false, default: '' },
});
</script>
